<template>
    <Modal size="md" @close="$emit('close')">
        <template #header>
            <div class="text-gray-600">Add members to team</div>
        </template>

        <template #body>
            <div class="space-y-4 p-6">
                <TextInput
                    id="emails"
                    v-model="form.emails"
                    type="text"
                    required
                    autofocus
                    label="Emails (comma-separated)"
                    placeholder="user1@example.com, user2@example.com"
                />

                <SelectInput
                    v-model="form.role"
                    required
                    label="Role"
                    placeholder="Select role"
                    :data="roleOptions"
                />
            </div>
        </template>

        <template #footer>
            <div class="flex justify-end gap-2 border-t border-gray-200 p-6">
                <AtomicButton color="white" size="md" @click="$emit('close')">
                    Cancel
                </AtomicButton>

                <AtomicButton
                    size="md"
                    color="yellow"
                    :disabled="loading"
                    @click="submit()"
                >
                    Add members
                </AtomicButton>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts" setup>
import Modal from '@/components/Atomic/Modals/Modal.vue';
import AtomicButton from '@/components/Atomic/Buttons/AtomicButton.vue';
import TextInput from '@atomic/Inputs/TextInput.vue';
import SelectInput from '@atomic/Inputs/SelectInput.vue';
import { router, usePage } from '@inertiajs/vue3';
import { route } from 'ziggy-js';
import { create } from '@/composables/useNotifications';
import ICurrentTeam from '@/types/Members/ICurrentTeam';

const props = defineProps<{
    team: ICurrentTeam;
}>();

const emit = defineEmits(['close']);

const form = ref({
    emails: '',
    role: 'viewer',
});

const loading = ref(false);

const roleOptions = [
    { value: 'admin', title: 'Admin' },
    { value: 'editor', title: 'Editor' },
    { value: 'viewer', title: 'Viewer' },
];

const submit = () => {
    if (!form.value.emails.trim()) {
        return;
    }

    loading.value = true;

    router.post(
        route('kiosk.teams.members.store', { team: props.team.id }),
        {
            emails: form.value.emails,
            role: form.value.role,
        },
        {
            preserveScroll: true,
            onSuccess: () => {
                const page = usePage();
                const message = (page.props.flash as { data?: { message?: string } })?.data?.message;

                create({
                    title: message || 'Members added successfully',
                    type: 'success',
                });
                emit('close');
            },
            onError: () => {
                create({
                    title: 'Failed to add members',
                    type: 'error',
                });
            },
            onFinish: () => {
                loading.value = false;
            },
        }
    );
};
</script>
